import { Component, ElementRef, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { User } from "@app/core/models";
import { AppState } from "@app/core/store/reducers";
import { selectCurrentUser } from "@app/core/store/reducers/users.reducer";
import { Store } from "@ngrx/store";
import { GlobalConstants } from "../global-constants";

@Component({
  selector: 'app-share-menu',
  template: ''
})
export class ShareMenuComponent {

  @ViewChild("sidebar")
  containerDiv: ElementRef;

  mainNav = GlobalConstants.mainNav;

  public isResultsSubnavActive = false;
  public isResultsSubnavCollapsed = true;
  public isResultsNavActive = false;

  public isGICSubnavActive = false;
  public isGICSubnavCollapsed = true;
  public isOnGICNavCollapsed = false;

  user: User;
  userName: string;
  routerLink = '/';

  constructor(protected store: Store<AppState>) {
    store.select(selectCurrentUser).pipe(takeUntilDestroyed()).subscribe(user => {
      if (!this.user && user) {
        this.user = user;
        this.userName = this.user.firstName + ' ' + this.user.lastName;

      }
    });
  }

  resetSubnavBars(): void {
    this.isResultsSubnavCollapsed = true;
    this.isResultsSubnavActive = false;
    this.isResultsNavActive = false;
  }

  
  toggleOnResultsNav(): void {
    this.isGICSubnavCollapsed = true;

    this.isResultsNavActive = true;
    this.isResultsSubnavCollapsed = false;
  }

  toggleOnResultsSubnav(): void {
    this.isResultsSubnavActive = !this.isResultsSubnavActive;
  }

  toggleOnGICNav(): void {
    this.isResultsSubnavCollapsed = true;
    
    this.isGICSubnavActive = true;
    this.isGICSubnavCollapsed = false;
  }

  toggleOnGICSubnav(): void {
    this.isGICSubnavActive = !this.isGICSubnavActive;
  }

  get badgeUserName(): string {
    return this.userName ? this.userName.charAt(0) + this.userName.charAt(this.userName.indexOf(' ') + 1) : '';
  }

  isShowMenu(navItem: any): boolean {
    if (navItem.title === 'FTP Searches') {
      return this.user && this.user.isFTPUser && this.user.allowSearch;
    } else if (navItem.title === 'Organizations') {
      return this.user && this.user.canAccessOrganizations;
    } else if (navItem.title === 'Users') {
      return this.user && this.user.canAccessUsers;
    }

    return true;
  }

  closeAllSubNavs(): void {
    this.isResultsSubnavCollapsed = true;
    this.isGICSubnavCollapsed = true;
  }
}
